import { render, staticRenderFns } from "./AlternativePayment.vue?vue&type=template&id=d04d3de6&scoped=true&"
import script from "./AlternativePayment.vue?vue&type=script&lang=js&"
export * from "./AlternativePayment.vue?vue&type=script&lang=js&"
import style0 from "./AlternativePayment.vue?vue&type=style&index=0&id=d04d3de6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d04d3de6",
  null
  
)

export default component.exports